import React, { useState } from 'react'
import {
    AppBar,
    Button,
    IconButton,
    Toolbar,
    useTheme,
    Avatar,
} from '@mui/material'
import { Add, ChatBubble, Home, Search } from '@mui/icons-material'
import { useLocation, useNavigate } from "react-router-dom";
import MediaPost from '../components/dialogs/MediaPost';
import Messages from '../pages/messages/Messages';




const Bottombar = ({ user }) => {
    const theme = useTheme()
    const location = useLocation();
    const navigate = useNavigate();

    const isActive = (path) => {
        if (path === "search") {
            return location.pathname.startsWith("/search");
        }
        return location.pathname === `/${path}`;
    };


    const [openCreatePostDialog, setOpenCreatePostDialog] = useState(false);

    const handleDialogOpen = () => {
        setOpenCreatePostDialog(true);
    };

    return (
        <React.Fragment>
            <AppBar
                position="fixed"
                sx={{
                    top: "auto",
                    bottom: 0,
                    backgroundColor: "background.paper",
                    display: { xs: "flex", sm: "flex", md: "none" },
                }}
            >
                <Toolbar sx={{ display: "flex", justifyContent: "space-around", gap: 1 }}>
                    <Button fullWidth
                        startIcon={<Home />}
                        sx={{
                            flexDirection: "column",
                            fontSize: "0.75rem",
                            textTransform: "none",
                            color: isActive("home")
                                ? theme.palette.primary.main
                                : theme.palette.text.secondary,
                            "& .MuiButton-startIcon": {
                                marginRight: 0,
                            }
                        }}
                        onClick={() => navigate("/home")}
                    >
                        Home
                    </Button>
                    <Button fullWidth
                        startIcon={<Search />}
                        sx={{
                            flexDirection: "column",
                            fontSize: "0.75rem",
                            textTransform: "none",
                            color: isActive("search")
                                ? theme.palette.primary.main
                                : theme.palette.text.secondary,
                            "& .MuiButton-startIcon": {
                                marginRight: 0,
                            }
                        }}
                        onClick={() => navigate("/search")}
                    >
                        Search
                    </Button>

                    <Avatar sx={{ bgcolor: theme.palette.background.default }}>
                        <IconButton color="primary" onClick={handleDialogOpen}>
                            <Add />
                        </IconButton>
                    </Avatar>

                   <Messages bottombar={true} />

                    <Button fullWidth
                        startIcon={
                            <Avatar
                                src={user.profilePicture}
                                alt={user.name}
                                sx={{ width: 22, height: 22 }}
                            />
                        }
                        sx={{
                            flexDirection: "column",
                            fontSize: "0.75rem",
                            textTransform: "none",
                            color: isActive("profile")
                                ? theme.palette.primary.main
                                : theme.palette.text.secondary,
                            "& .MuiButton-startIcon": {
                                marginRight: 0,
                            }
                        }}
                        onClick={() => navigate(`/profile/${user.username}`)}
                    >
                        Profile
                    </Button>
                </Toolbar>
            </AppBar>

            <MediaPost
                openDialog={openCreatePostDialog}
                handleCloseDialog={() => setOpenCreatePostDialog(false)}
            />
        </React.Fragment>
    )
}

export default Bottombar
